module.exports = __webpack_public_path__ + "img/03-main.91858a0f.svg";